import { render, staticRenderFns } from "./ProductNewSubstituitionPage.vue?vue&type=template&id=812e714e&"
import script from "./ProductNewSubstituitionPage.vue?vue&type=script&lang=js&"
export * from "./ProductNewSubstituitionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports